import { render, staticRenderFns } from "./PageOverlay.vue?vue&type=template&id=eabb58b8&scoped=true"
import script from "./PageOverlay.vue?vue&type=script&lang=js"
export * from "./PageOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabb58b8",
  null
  
)

export default component.exports